import { IconBuildingOff, IconMapPinShare, IconSwitchHorizontal, IconUserOff } from "@tabler/icons-react"
import type { ComponentType } from "react"
import { cn } from "@/lib/utils"
import { OVERRIDE_KIND_LABEL, type OverrideKindKey } from "../lib/overrideOverlay"

const ICON: Record<OverrideKindKey, ComponentType<{ className?: string; "aria-hidden"?: boolean }>> = {
  siteClosure: IconBuildingOff,
  eventTypeOverride: IconSwitchHorizontal,
  outOfOffice: IconUserOff,
  outreachAssignment: IconMapPinShare,
}

/**
 * An override kind's icon (AB#803): the marker's non-colour cue, named for a screen reader as the
 * calendar names its note icon (SlotCell).
 */
export function OverrideKindIcon({ kind, className }: { kind: OverrideKindKey; className?: string }) {
  const Icon = ICON[kind]
  const label = OVERRIDE_KIND_LABEL[kind]
  return (
    <span role="img" aria-label={label} className={cn("inline-flex shrink-0", className)} data-override-kind={kind}>
      <Icon className="size-3" aria-hidden />
    </span>
  )
}
